import ajax from './axios'

// kqi filter
export const getKqiFilter = (zh = false) => {
    // return ajax.post('/api/v2/aceranking/filter', params)
    return ajax.get('/api/v2/statistics/filter?index=CCF&zh=' + zh)
}

// kqi paper/author list
export const getKqiMsgList = (params) => {
    return ajax.post('/api/v2/statistics/list', params)
}


// WEBPACK FOOTER //
// ./src/api/kqi.js